import React, { createContext, useContext, useState } from "react";

const HighlightKeyContext = createContext();

export const HighlightKeyProvider = ({ children }) => {
  const [highlightedNote, setHighlightedNote] = useState(null);

  return (
    <HighlightKeyContext.Provider
      value={{ highlightedNote, setHighlightedNote }}
    >
      {children}
    </HighlightKeyContext.Provider>
  );
};

export const useHighlightKey = () => useContext(HighlightKeyContext);
